var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,33.83V47.28A2.81,2.81,0,0,1,47.07,50H2.78A2.82,2.82,0,0,1,0,47.2V2.79A2.8,2.8,0,0,1,2.77,0H23.18a2.79,2.79,0,0,1,2.75,2.74,2.83,2.83,0,0,1-2.43,2.9,6,6,0,0,1-.74,0h-17V44.27H44.33V33.74a2.77,2.77,0,0,1,1.49-2.6l.27-.12A3,3,0,0,1,50,33.83Zm-33.85-14a16.31,16.31,0,0,0-3.6,10.34,3.06,3.06,0,0,0,6.12,0,12.92,12.92,0,0,1,.15-1.75,10.65,10.65,0,0,1,10.63-8.9c3.29,0,6.57,0,9.85,0,.18,0,.36,0,.63,0l-.4.49c-2,2.24-4,4.47-6.05,6.72A3.06,3.06,0,1,0,38,31q5.56-6.15,11.1-12.34a3,3,0,0,0,.27-3.86c-.35-.47-.73-.91-1.12-1.35L38.15,2.22a3.09,3.09,0,0,0-4.44-.46,3,3,0,0,0-.16,4.5c1.16,1.31,2.34,2.61,3.52,3.92L40,13.43H29.37a17.84,17.84,0,0,0-2.07.14A16.54,16.54,0,0,0,16.15,19.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.dd6b6104357049168e867ea1f8ad75fd.svg";
export { ForwardRef as ReactComponent };